import "./styles/app.scss";
import "react-simple-keyboard/build/css/index.css";
import "simplebar/dist/simplebar.css";

import { observer } from "mobx-react-lite";
import React from "react";
import { useContext, useEffect } from "react";
import { v4 as uuidv4 } from "uuid";

import FooterShare from "./components/FooterShare";
import { ApiContext, UserContext } from "./contexts";
import YourNewHomeScreen from "./screens/YourNewHomeScreen";
import {
  Consultant,
  ExteriorStyle,
  Home,
  InteriorStyle,
  Region,
  Series,
  SessionState,
  User,
} from "./types";

const MyDomaineApp = observer(
  (props: {
    settings: any;
    regions: Region[];
    nswRegions: Region[];
    consultants: Consultant[];
    exteriorStyles: ExteriorStyle[];
    interiorStyles: InteriorStyle[];
    series: Series[];
    home?: Home;
    uuid?: string;
    user?: User;
    sessionState?: SessionState;
    myDomainMode: boolean;
    shareMode: boolean;
  }) => {
    const apiContext = useContext(ApiContext);
    const userContext = useContext(UserContext);

    useEffect(() => {
      // We need to reset the stores otherwise old mobx state will be re-used as the user clicks between completed homes
      userContext.reset();
      apiContext.reset();

      userContext.setIsMyDomaineMode(props.myDomainMode);
      userContext.setIsShareMode(props.shareMode);
      if (props.uuid) {
        userContext.setUUID(props.uuid);
      } else {
        userContext.setUUID(uuidv4());
      }

      if (props.user) {
        userContext.setEmail(props.user.email);
        userContext.setFirstName(props.user.name);
        userContext.setLastName(props.user.surname);
        userContext.setPhone(props.user.phone);
        userContext.setEmail(props.user.email);
        apiContext.setRegion(props.user.region ? props.user.region : null);
        userContext.setEmailSecondary(props.user.email_secondary ? props.user.email_secondary : "");
        userContext.setIsLoggedIn(true);
      }

      apiContext.setInitialAppData(
        props.settings,
        props.regions,
        props.nswRegions,
        props.consultants,
        props.exteriorStyles,
        props.interiorStyles,
        props.series
      );
      if (props.home && props.sessionState) {
        userContext.restoreSessionState(props.home, props.sessionState);
      }
    }, []);
    return (
      <>
        <div className={"pyht-app my-domaine-mode"}>
          <YourNewHomeScreen />
          {!userContext.isShareMode && <FooterShare />}
        </div>
      </>
    );
  }
);

export default MyDomaineApp;
